import { Maybe, Operation } from '../../../__generated__/globalTypes'

import sendOrderString from '../SendOrder.graphql'

export type SendOrderData = {
  sendOrder: {
    order: {
      id: string
    }
  }
}

export type SendOrderVariables = {
  order: string
  buyPointsAndExpense?: Maybe<boolean>
  shouldUseCredits?: Maybe<boolean>
}

export type SendOrder = Operation<SendOrderData, SendOrderVariables>

export const SendOrder = ({
  order,
  buyPointsAndExpense,
  shouldUseCredits,
}: SendOrderVariables): SendOrder => ({
  query: sendOrderString,
  variables: {
    order,
    buyPointsAndExpense,
    shouldUseCredits,
  },
})
